import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
const PDPDesktopMarxentConfigurator = t0 => {
  const $ = _c(25);
  const {
    slug,
    hideMarxent,
    unavailableFabric: t1
  } = t0;
  const unavailableFabric = t1 === undefined ? false : t1;
  const {
    data
  } = usePDPBasicDetails();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <link href="https://cdn.3dcloud.io/joy-sectional-config/7.2.0-12/JOYSectional-7.2.0-12.css" rel="stylesheet" type="text/css" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `marxent-script-${slug}`;
  let t4;
  if ($[1] !== t3) {
    t4 = <Helmet>{t2}<script src="https://cdn.3dcloud.io/joy-sectional-config/7.2.0-12/JOYSectional-7.2.0-12.min.js" id={t3} type="text/javascript" async={true} defer={true} /></Helmet>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== data) {
    t5 = data?.hero_images[0]?.img?.url && <JBImage className="w-full h-full absolute object-cover z-0" src={data.hero_images[0].img.url} fit="crop" crop="center" width="600" height="400" />;
    $[3] = data;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-gray-light9 absolute z-10 p-4 rounded-sm text-sm font-bold">Add a piece to get started!</div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <div className="w-full h-full flex justify-center items-center absolute">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = !hideMarxent;
  let t9;
  if ($[8] !== hideMarxent || $[9] !== t8) {
    t9 = classnames("w-full h-full absolute z-20 bg-gray-light9 transition-all duration-500", {
      "opacity-0": hideMarxent,
      "opacity-100": t8
    });
    $[8] = hideMarxent;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `marxent-configurator-${slug}`;
  let t11;
  if ($[11] !== t10) {
    t11 = <div className="w-full h-full relative [&_.closeButton]:hidden" id={t10} />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t9) {
    t12 = <div className={t9}>{t11}</div>;
    $[13] = t11;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== unavailableFabric) {
    t13 = unavailableFabric && <div className="w-full h-full flex justify-center items-center"><div className="bg-brand absolute z-30 px-4 py-2 rounded-md text-sm text-white font-bold text-center">This fabric is coming soon!<br />Check out our other fabrics while we get our ducks in a row.</div></div>;
    $[16] = unavailableFabric;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12 || $[19] !== t13 || $[20] !== t7) {
    t14 = <div className="border border-gray-light6 w-full h-[60vh] relative">{t7}{t12}{t13}</div>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t7;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t4) {
    t15 = <>{t4}{t14}</>;
    $[22] = t14;
    $[23] = t4;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};
PDPDesktopMarxentConfigurator.propTypes = {
  slug: PropTypes.string,
  hideMarxent: PropTypes.bool,
  unavailableFabric: PropTypes.bool
};
export default PDPDesktopMarxentConfigurator;